import { Pill } from "ui/Pill/Pill";

type NumberTextPillProps = {
  number: number;
  text: string;
  color: string;
  testIdNumber?: string;
  testIdText?: string;
};

export function NumberTextPill({
  number,
  text,
  color,
  testIdNumber,
  testIdText,
}: NumberTextPillProps) {
  return (
    <Pill color={color} bg="white" bordered>
      <Pill.Number data-testid={testIdNumber}>{number}</Pill.Number>
      <Pill.Text data-testid={testIdText}>{text}</Pill.Text>
    </Pill>
  );
}
